import React, { useRef, useEffect } from "react";
import Lottie from "lottie-react";

const LottieAnimation = ({
  animationSource, // Animation JSON file
  size = 100, // Default width & height
  margin = 0, // Default margin
  loop = false, // Default loop behavior
  autoPlay = true, // Default autoplay
  customStyles = {},
  lottieRef,
}) => {
  const animationRef = useRef();

  useEffect(() => {
    return () => {
      if (animationRef.current) {
        animationRef.current.destroy?.(); // Destroy the animation instance
      }
    };
  }, []);

  useEffect(() => {
    if (lottieRef && animationRef.current) {
      lottieRef.current = animationRef.current;
    }
  }, [lottieRef]);

  const onComplete = () => {
    console.log("Animation complete, destroying...");
    animationRef?.current?.destroy?.();
  };

  return (
    <Lottie
      lottieRef={animationRef}
      style={{
        width: typeof size === "number" ? `${size}px` : size,
        height: typeof size === "number" ? `${size}px` : size,
        margin: typeof margin === "number" ? `${margin}px 0px` : margin,
        position: "relative",
        ...customStyles,
      }}
      animationData={animationSource}
      autoPlay={autoPlay}
      loop={loop}
      onComplete={onComplete}
    />
  );
};

export default LottieAnimation;
